import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { borrowingQuotaShape } from '@bibliocommons/bc-prop-types';

import BorrowingQuota from '../BorrowingQuota';

import './BorrowingQuotas.scss';

export default function BorrowingQuotas({ title, quotas }) {
  const renderedQutoas = quotas
    .filter(quota => quota.get('type') !== 'ILS')
    .map(quota => <BorrowingQuota quota={quota} />);

  return (
    <div className="cp-borrowing-quotas">
      <h2>{title}</h2>
      {renderedQutoas}
    </div>
  );
}

BorrowingQuotas.propTypes = {
  title: PropTypes.element,
  quotas: ImmutablePropTypes.listOf(borrowingQuotaShape)
};



// WEBPACK FOOTER //
// ./app/components/borrowing/shared/BorrowingQuotas/BorrowingQuotas.jsx